module.exports = __webpack_public_path__ + "static/media/IMG_20190130_112416980.e72f2763.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/IMG_20190130_112416980.jpg
// module id = 42
// module chunks = 0